<template>
  <footer>
    <div class="wrapper">
      <div class="department">
        <h4>Hato Press</h4>
        <p>217 Mare Street<br>E8 3QE London</p>
        <p>+44 (0) 20 7729 5585<br><a href="mailto:info@hatopress.net">info@hatopress.net</a><br><a href="https://instagram.com/hatopress" target="_blank">@hatopress</a></p>
      </div>
      <div class="department">
        <h4>Printing</h4>
        <p>Got a question about the printing process or setting up your artwork?</p>
        <p><a href="mailto:info@hatopress.net">info@hatopress.net</a></p>
      </div>
      <div class="department">
        <h4>Workshops</h4>
        <p>All our workshops are framed around our belief that having fun is the best way to learn something new.</p>
        <p>For workshop classes and general enquiry: <a href="mailto:learn@hatopress.net">learn@hatopress.net</a></p>
        <p>For bespoke workshops, strategy or partnership: <a href="mailto:bespoke@hatopress.net">bespoke@hatopress.net</a></p>
      </div>
      <div class="department">
        <h4>Shop</h4>
        <p>Get a copy of our latest books, prints, stationery and more.</p>
        <p><a href="mailto:shop@hatopress.net">shop@hatopress.net</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'bye'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer {
  padding: 20px 20px 40px;
  background: #fafafa;
  /* background-color: rgb(55,234,168); */
  background-color: hsl(158, 90%, 66%);
}
.wrapper {
  max-width: 1000px;
  margin: auto;
  display: flex;
  flex-direction: row;
}
.department {
  width: 27%;
  padding: 14px;
}
.department:first-child {
  width: 19%
}
h4 {
  font-weight: 500
}
a {
  text-decoration: underline;
}
footer, footer p, footer h4 {
  font-size: 14px;
  line-height: 20px;
  /*letter-spacing: -0.5px;*/
}

@media screen and (max-width: 768px) {
  footer {
    padding: 20px 15px 20px;
    padding-top: 2rem;
    padding-bottom: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .wrapper {
    max-width: 1000px;
    /*flex-direction: column;*/
    flex-wrap: wrap;
  }
  .department, .department:first-child {
    width: 50%;
    padding: 0 1rem 0 0;
  }
}
@media screen and (max-width: 640px) {
  .department, .department:first-child {
    width: 100%;
    padding: 0 1rem 1.5rem 0;
  }
  p {
    margin-top: .5em;
    margin-bottom: .5em;
  }
}

</style>



// WEBPACK FOOTER //
// HatoPressFooter.vue?a8706182